import { Fragment } from "react";
import { Flex, Tag, TagLabel } from "@chakra-ui/react";
import { CatalogoDisparo, ContextoDisparo } from "@/models/consignado/disparo.model";
import { GrupoNo } from "./filtro-arvore";
import { propriedade as buscarPropriedade, detalheDaCondicao } from "./catalogo.helpers";
import { brandSolid, fieldFont } from "./styleTokens";

type Props = {
  grupo: GrupoNo;
  contexto: ContextoDisparo;
  catalogo?: CatalogoDisparo;
};

/**
 * A árvore do filtro em leitura, no desenho do formulário em tamanho menor:
 * as mesmas pílulas, o conector E/OU entre elas e o subgrupo com borda
 * tracejada no lugar do parêntese.
 */
export default function FiltroMiniatura({ grupo, contexto, catalogo }: Props) {
  return (
    <Flex align="center" gap={1} wrap="wrap">
      {grupo.itens.map((no, index) => (
        <Fragment key={no.id}>
          {index > 0 && (
            <Tag size="sm" borderRadius="md" letterSpacing="0.05em" {...brandSolid("secondary")} {...fieldFont}>
              <TagLabel fontWeight="700">{grupo.combinador}</TagLabel>
            </Tag>
          )}
          {no.tipoNo === "condicao" ? (
            <Tag size="sm" borderRadius="full" {...brandSolid("secondary")} {...fieldFont}>
              <TagLabel>
                {buscarPropriedade(catalogo, contexto, no.propriedade)?.descricao ?? no.propriedade}{" "}
                {detalheDaCondicao(catalogo, contexto, no)}
              </TagLabel>
            </Tag>
          ) : (
            <Flex borderWidth="1px" borderStyle="dashed" borderColor="secondary" borderRadius="md" p={1}>
              <FiltroMiniatura grupo={no} contexto={contexto} catalogo={catalogo} />
            </Flex>
          )}
        </Fragment>
      ))}
    </Flex>
  );
}
